import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ApiKey } from "types/generated";

const PersonalApiKeysTableCreatedAtCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<Pick<ApiKey, "createdAt">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp variant="p-body3" timestamp={apiKey.createdAt} />
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableCreatedAtCell;
